var React = require('react');

function Hu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#436F4D","width":"6","height":"3","key":0}),React.createElement("rect",{"fill":"#FFF","width":"6","height":"2","key":1}),React.createElement("rect",{"fill":"#CD2A3E","width":"6","height":"1","key":2})]);
}

Hu.defaultProps = {"viewBox":"0 0 6 3"};

module.exports = Hu;

Hu.default = Hu;
